import {
  CallHistoryService,
  CallListItem,
  Core,
  isCallListGetResult,
  isCallListItemRemoveResult,
  isCallListItemAddResult,
  SorensonAccountProvider,
} from "@sorenson-eng/videophone-core-services";
import { SorensonCallHistoryService } from "./SorensonCallHistoryService";

const sorensonAccount = new SorensonAccountProvider();

export class SorensonCallHistoryProvider implements CallHistoryService {
  callHistoryItems?: CallListItem[];

  async fetchCallHistory(type: string): Promise<SorensonCallHistoryService> {
    let requestBody = {
      CallListGet: {
        CallList: {
          $: {
            Type: type,
            BaseIndex: 0,
            Count: 9999,
            SortField: "Time",
            SortDir: "DESC",
            FlagAddressBook: "True",
          },
        },
      },
    };

    try {
      const coreResponse = await Core.getInstance().coreRequest(requestBody);

      if (!isCallListGetResult(coreResponse)) {
        return Promise.reject("Call List Get: error parsing response");
      }

      if (coreResponse.CallListGetResult.$.Result === "Error") {
        return Promise.reject("Error in call history fetch response");
      }

      let serviceResponse = new SorensonCallHistoryService();
      serviceResponse.callHistoryItems = new Array<CallListItem>();

      if (coreResponse.CallListGetResult.CallList.$.Count > 0) {
        const callList = coreResponse.CallListGetResult.CallList
          .CallListItem as CallListItem | CallListItem[];
        if (Array.isArray(callList)) {
          serviceResponse.callHistoryItems.push(...callList);
        } else {
          serviceResponse.callHistoryItems.push(callList);
        }
      }

      return Promise.resolve(serviceResponse);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteCallHistory(id: number, type: string): Promise<boolean> {
    let requestBody = {
      CallListItemRemove: {
        CallList: {
          $: {
            Type: type,
          },
          CallListItem: {
            ItemId: [id],
          },
        },
      },
    };

    try {
      const coreResponse = await Core.getInstance().coreRequest(requestBody);

      if (!isCallListItemRemoveResult(coreResponse)) {
        return Promise.reject("Call List Delete: error parsing response");
      }

      if (coreResponse.CallListItemRemoveResult.$.Result === "Error") {
        return Promise.reject("Error in call history delete response");
      }

      if (coreResponse.CallListItemRemoveResult.$.Result === "OK") {
        return Promise.resolve(true);
      }
    } catch (error) {
      return Promise.reject(error);
    }

    return Promise.reject("Error");
  }

  async addCallHistory(item: CallListItem, type: string): Promise<boolean> {
    let requestBody = {
      CallListItemAdd: {
        CallList: {
          $: {
            Type: type,
          },
          CallListItem: item,
        },
      },
    };

    try {
      const coreResponse = await Core.getInstance().coreRequest(requestBody);

      if (!isCallListItemAddResult(coreResponse)) {
        return Promise.reject("Call List Add: error parsing response");
      }

      if (coreResponse.CallListItemAddResult.$.Result === "Error") {
        return Promise.reject("Error in call history add response");
      }

      if (coreResponse.CallListItemAddResult.$.Result === "OK") {
        return Promise.resolve(true);
      }
    } catch (error) {
      return Promise.reject(error);
    }

    return Promise.reject("Error");
  }
}
